import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import SingleEvent from '../../components/Event';
import DataState from '../../components/DataState';
import RightArrow from '../../components/SVG';
import { useCollections } from '../../lib/api/collections';
import { eventImages } from '../../data/images';
import EventCalendar from './EventCalendar';

const PAGE_SIZE = 6;

const EventMain = () => {
  const content = useCollections('events');
  const [params, setParams] = useSearchParams();
  const [shown, setShown] = useState(PAGE_SIZE);
  if (content.loading || content.error) return <DataState state={content} />;
  const view = params.get('view') === 'calendar' ? 'calendar' : 'list';
  // Newest first. Only published events with a summary are listed, six at a time.
  const withSummary = content.events.filter((e) => e.summary);
  const listed = withSummary.slice(0, shown);

  return (
    <main>
      <Breadcrumb title="Campus Events" subTitle="Events" />
      <div className="it-event-2-area it-event-style-3 p-relative pt-90 pb-90">
        <div className="container">
          <div className="sc-view-toggle" role="tablist" aria-label="Events view">
            <button type="button" className={view === 'list' ? 'active' : ''} onClick={() => setParams({})}>List</button>
            <button type="button" className={view === 'calendar' ? 'active' : ''} onClick={() => setParams({ view: 'calendar' })}>Calendar</button>
          </div>
          {view === 'calendar' ? (
            <EventCalendar events={content.events} />
          ) : (
            <div className="row">
              {listed.map((e) => (
                <div key={e.id} className="col-xl-4 col-lg-6 col-md-6 mb-30">
                  <SingleEvent
                    to={`/events/${e.id}`}
                    eventImage={eventImages(e).card}
                    eventDate={String(e.day).padStart(2, '0')}
                    eventMonth={e.month}
                    title={e.title}
                    description={e.summary}
                    eventType={e.type}
                    eventLocation={e.location}
                  />
                </div>
              ))}
              {withSummary.length > listed.length && (
                <div className="col-12 text-center mt-20 sc-more">
                  <button type="button" className="ed-btn-theme" onClick={() => setShown(shown + PAGE_SIZE)}>
                    <span>
                      Show more events
                      <i>
                        <RightArrow />
                      </i>
                    </span>
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </main>
  );
};
export default EventMain;
